export default {
  namespaced: true,
  state: {
    data: [],
    loaded: false,
  },
  mutations: {
    saveData(state, data) {
      state.data = data;
    },
    load(state) {
      state.loaded = true;
    }
  },
  actions: {
    loadNutrients(context, payload) {
      return env.API.get('/nutrients').then(res => {
        context.commit('saveData', res.data);
        context.commit('load');
      });
    }
  },
  getters: {
    topLevelNutrients(state) {
      return state.data.map(n => {
        if(n.types) {
          return {
            label: n.types[0].label,
            key: n.key,
          };
        } else {
          return {
            label: n.label,
            key: n.key,
          };
        }
      });
    },
    cropNutrients(state, rootGetters) {
      // console.log(rootGetters[]);
      let exclude = ['NNO3', 'NNH2', 'NNH4', 'Na', 'Cl', 'HCO3', 'Al'];
      return rootGetters['topLevelNutrients'].filter(x => {
        if (!exclude.includes(x.key)) {
          return x;
        }
      })
    },
    all(state) {
      return state.data;
    },
    nForms(state) {
      return state.data.filter(n => n.n_form);
    },
    data(state) {
      return state.data.filter(n => !n.n_form);
    },
    isLoaded(state) {
      return state.loaded;
    },
    getNutrientByKey: (state, getters) => key => {
      return state.data.find(n => n.key === key);
    },

    getUnitFromPPm: state => (key, unit, val) => {
      var nut = state.data.find(n => {
        if (n.key === key) {
          return true;
        } else {
          if (n.types) {
            var temp = n.types.find(type => {
              if (type.label === key) {
                return true;
              }
              return false;
            });
            if (temp && n.key.length < temp.label.length) {
              return true;
            }
          }
        }
        return false;
      });
      var res = val / (1 / nut.units[unit]);

      if (res) {
        return res;
      } else {
        return 0;
      }
    },


    getPPmFromUnit: state => (key, unit, val) => {
      var nut = state.data.find(n => {
        if (n.key === key) {
          return true;
        } else {
          if (n.types) {
            var temp = n.types.find(type => {
              if (type.label === key) {
                return true;
              }
              return false;
            });
            if (temp && n.key.length < temp.label.length) {
              return true;
            }
          }
        }
        return false;
      });
      // var res = val / nut.units[unit];
      var res = val * (1 / nut.units[unit]);

      if (res) {
        return res;
      } else {
        return 0;
      }
    },


    containsUnit: state => (key) => {
      var nut = state.data.find(n => n.key === key);
      if (nut.units) {
        return true;
      }
      return false;
    },

    getVal: state => (nut, active, value) => {
      var nut = state.data.find(n => n.key === nut);
      var type = nut.types.find(type => type.label === active)
      var val = value * type.value;

      return val;
    },

    getOriginal: state => (nut, active, value) => {
      var nut = state.data.find(n => n.key === nut);
      var type = nut.types.find(type => type.label === active)
      var val = value * (1 / type.value);

      return val;
    },
    convertNut: state => (nut, from, to, value) => {
      var nut = state.data.find(n => n.key === nut);
      var type_from = nut.types.find(type => type.label === from);
      var type_to = nut.types.find(type => type.label === to);
      var origin = value * (1 / type_from.value);
      var val = origin / (1 / type_to.value);

      return val;
    },

    // TODO: добавить переконвертацию ИЗ одного нутриента в другой,
    // если там несколько видов
  }
};
